const cookieNotification = {
	cookieElement: $('.js-cookie-notification'),
	cookieButtonElement: $('.js-cookie-notification-btn'),
	cookieButtonCloseElement: $('.js-cookie-notification-btn-close'),

	isCookieExist: function() {
		return Cookies.get('cookie-confirm');
	},

	setCookie: function() {
		return Cookies.set('cookie-confirm', '1');
	},

	init: function() {
		const _cookie = this;
		if (!this.isCookieExist()) {
			setTimeout(function() {
				_cookie.toggleCookie(true);
			}, 2000);
			this.createListeners();
		}
	},

	createListeners: function() {
		const _cookie = this;
		this.cookieButtonElement.on('click', function() {
			_cookie.toggleCookie(false);
			_cookie.setCookie();
		});
		this.cookieButtonCloseElement.on('click', function () {
			_cookie.toggleCookie(false);
		})
	},

	toggleCookie: function(isShow) {
		this.cookieElement.toggle(isShow);
	}
};

cookieNotification.init();
